import Vue from "vue";
import moment from "moment";

//Moment filter
Vue.filter("formatDate", value => {
  return moment(value).format("MM/DD/YYYY hh:mm a");
});
